import { render } from "./ProfilePublications.vue?vue&type=template&id=126307be&scoped=true"
import script from "./ProfilePublications.vue?vue&type=script&lang=js"
export * from "./ProfilePublications.vue?vue&type=script&lang=js"

import "./ProfilePublications.vue?vue&type=style&index=0&id=126307be&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126307be"]])

export default __exports__